export default __webpack_public_path__ + "static/media/icon_add_group_project.d2f4308c.svg";